var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommissionDegreeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "certificate-solid",
    d: "M8.614.26A.984.984,0,0,0,6.953.7L6.3,3.266,3.762,2.548A.982.982,0,0,0,2.548,3.762L3.266,6.3.7,6.957a.99.99,0,0,0-.709.7.964.964,0,0,0,.267.956l1.895,1.845L.26,12.3A.984.984,0,0,0,.7,13.965l2.563.648-.718,2.543A.982.982,0,0,0,3.762,18.37L6.3,17.652l.648,2.563a.987.987,0,0,0,1.661.447l1.845-1.895L12.3,20.662a.981.981,0,0,0,.96.262,1,1,0,0,0,.7-.709l.648-2.563,2.543.718a.982.982,0,0,0,1.214-1.214l-.718-2.543,2.563-.648a.99.99,0,0,0,.709-.7.979.979,0,0,0-.262-.96l-1.895-1.845,1.895-1.845a.981.981,0,0,0,.262-.96,1,1,0,0,0-.709-.7L17.652,6.3l.718-2.543a.982.982,0,0,0-1.214-1.214l-2.543.718L13.961.7a.99.99,0,0,0-.7-.709A.965.965,0,0,0,12.3.26L10.459,2.155Z",
    transform: "translate(0.041 0.041)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionDegreeIcon);
export default __webpack_public_path__ + "static/media/commission-degree-icon.d073e09aa96d82e323de064111543588.svg";
export { ForwardRef as ReactComponent };